import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { pluralize } from 'src/utils/text';

// ########
// HELPERS
// ########

/**
 * Formats additional services text if order has multiple services
 * @param {number} totalServices - Total number of services in the order
 */
const formatAdditionalServices = (totalServices) => {
  if (totalServices <= 1) return '';

  const additionalServices = totalServices - 1;
  return ` + ${additionalServices} ${pluralize('service', additionalServices)}`;
};

/**
 * Formats a summary of the order's services
 * @param {Order} order - Order object containing service information
 */
const formatServiceSummary = (order) => {
  const services = get(order, 'breakdown.services', []);
  if (!services.length) return '';

  const mainService = services[0].name;
  const additionalServices = formatAdditionalServices(services.length);
  const summary = `${mainService}${additionalServices}`;

  return order.remote ? `Remote ${summary}` : summary;
};

// ###########
// COMPONENT
// ###########

/** @param {{order: Order}} */
export const ServiceHeading = ({ order }) => (
  <h5 className="marginRight-small">{formatServiceSummary(order)}</h5>
);

// ###########
// PROP TYPES
// ###########

ServiceHeading.propTypes = { order: PropTypes.object.isRequired };

/** @typedef {import ('src/types/order').Order} Order */
